import * as api from '../../api'
import * as types from '../../mutation-types'
import router from '../../../router'

const state = {
  user: [],
  users: [],
  users_received_timestamp: new Date(0),
  groups: []
}

const getters = {
  singleUser: state => state.user,
  allUsers: state => state.users,
  allGroups: state => state.groups
}

const actions = {
  getUsers ({ commit }) {
    const diff = Math.abs(new Date(state.users_received_timestamp) - new Date())
    const diffMinutes = Math.floor((diff / 1000) / 60)
    if (diffMinutes >= 1) {
      api.instance.get('users')
        .then(function (response) {
          const users = response.data.users
          commit(types.RECEIVE_USERS, users)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  getUser ({ commit }, userId) {
    api.instance.get('users/' + userId)
      .then(function (response) {
        const user = response.data.user
        commit(types.RECEIVE_USER, user)
      })
  },
  getGroups ({ commit }) {
    api.instance.get('groups')
      .then(function (response) {
        const groups = response.data.groups
        commit(types.RECEIVE_GROUPS, groups)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  addEditUser ({ commit, rootGetters }, user) {
    if (user.username !== '') {
      if (user.password !== '') {
        if (user.user_id === 0) {
          if (user.group_id === 1 || user.group_id === 2) {
            user.assigned_site_ids.push(rootGetters.scopedSiteId)
          }

          api.instance.post('users', user)
            .then(function (response) {
              if (response.data.success === 'true') {
                user.group = state.groups.filter(function (el) {
                  if (el.group_id === user.group_id) {
                    return true
                  }
                })[0]
                user.user_id = response.data.user[0].user_id
                commit(types.ADD_USER, user)

                router.push({ name: 'AdminUsersIndex' })
              } else {
                alert(response.data.message)
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        } else {
          api.instance.put('users/' + user.user_id, user)
            .then(function (response) {
              if (response.data.success === 'true') {
                user.group = state.groups.filter(function (el) {
                  if (el.group_id === user.group_id) {
                    return true
                  }
                })[0]
                commit(types.EDIT_USER, user)
                router.push({ name: 'AdminUsersIndex' })
              } else {
                alert(response.data.message)
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        }
      } else {
        alert('Password is required')
      }
    } else {
      alert('Name is required')
    }
  },
  deleteUser ({ commit }, user) {
    api.instance.delete('users/' + user.user_id)
      .then(function (response) {
        commit(types.DELETE_USER, user)
      })
  }
}

const mutations = {
  [types.RECEIVE_USERS] (state, users) {
    state.users = users
    state.users_received_timestamp = Date.now()
  },
  [types.RECEIVE_USER] (state, user) {
    state.user = user
  },
  [types.RECEIVE_GROUPS] (state, groups) {
    state.groups = groups
  },
  [types.ADD_USER] (state, user) {
    state.users.push(user)
  },
  [types.EDIT_USER] (state, user) {
    let userToEdit = state.users.find(
      function (ele) {
        if (ele.user_id === user.user_id) {
          return true
        }
      }
    )
    let index = state.users.indexOf(userToEdit)
    state.users[index] = user
  },
  [types.DELETE_USER] (state, user) {
    let userToDelete = state.users.find(
      function (ele) {
        if (ele.user_id === user.user_id) {
          return true
        }
      }
    )
    let index = state.users.indexOf(userToDelete)
    state.users.splice(index, 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
